class SdProductDescription extends HTMLElement {
  connectedCallback() {
    if (this.resizeObserver) return;

    const content = this.querySelector('[data-description-content]');
    const button = this.querySelector('[data-description-toggle]');
    if (!content || !button) return;

    const sync = () => {
      const needsToggle = content.scrollHeight > 152;
      this.classList.toggle('is-collapsible', needsToggle);
      button.hidden = !needsToggle;
    };

    const toggle = () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      button.textContent = expanded ? this.dataset.moreLabel : this.dataset.lessLabel;
      this.classList.toggle('is-expanded', !expanded);
    };

    if (button.dataset.toggleReady !== 'true') {
      button.dataset.toggleReady = 'true';
      button.addEventListener('click', toggle);
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    }

    requestAnimationFrame(sync);
    this.resizeObserver = new ResizeObserver(sync);
    this.resizeObserver.observe(content);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
  }
}

if (!customElements.get('sd-product-description')) {
  customElements.define('sd-product-description', SdProductDescription);
}
